"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../context");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _constants = require("../../utils/constants");

var _constants2 = require("../html/constants");

var _interfaces = require("../interfaces");

var _constants3 = require("./constants");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TableHeaderButtonContent = (0, _context.styledWithTheme)(_layout.Row)(function (_ref) {
  var theme = _ref.theme,
      spacing = _ref.spacing;
  var selectors = theme.selectors;
  var paddingHorizontal = (0, _utils.px)(selectors.space(_constants2.CELL_SPACING_HORIZONTAL));
  var paddingVertical = (0, _utils.px)(theme.selectors.space(spacing === _interfaces.TableSpacing.Reduced ? _constants2.HEADER_SPACING_VERTICAL_REDUCED : _constants2.HEADER_SPACING_VERTICAL));
  return {
    padding: "".concat(paddingVertical, " ").concat(paddingHorizontal)
  };
});
var TableHeaderButtonBase = (0, _context.styledWithTheme)('button')(function (_ref2) {
  var theme = _ref2.theme,
      isFocusedByTab = _ref2.isFocusedByTab;
  var selectors = theme.selectors;
  return {
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    boxSizing: 'border-box',
    color: selectors.color('neutral90'),
    cursor: 'pointer',
    fontFamily: selectors.fontFamily('primary'),
    fontSize: (0, _utils.px)(selectors.fontSize('T200')),
    fontWeight: selectors.fontWeight('regular'),
    justifyContent: 'center',
    outline: 'none',
    textAlign: 'center',
    transition: 'box-shadow .2s, border-color .2s',
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    ':hover': {
      outline: "".concat(_constants3.TABLE_HEADER_BUTTON_BORDER_WIDTH, "px solid ").concat(selectors.color(_constants3.TABLE_HEADER_BUTTON_BORDER_COLOR)),
      outlineOffset: "-".concat(_constants3.TABLE_HEADER_BUTTON_BORDER_WIDTH - 1, "px")
    },
    ':focus': isFocusedByTab ? {
      outline: "".concat(_constants3.TABLE_HEADER_BUTTON_BORDER_WIDTH, "px solid ").concat(selectors.color(_constants3.TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR)),
      outlineOffset: "-".concat(_constants3.TABLE_HEADER_BUTTON_BORDER_WIDTH - 1, "px")
    } : undefined
  };
});

var TableHeaderButton = function TableHeaderButton(_ref3) {
  var sortDirection = _ref3.sortDirection,
      spacing = _ref3.spacing,
      onClick = _ref3.onClick,
      titleText = _ref3.titleText,
      justifyContent = _ref3.justifyContent,
      children = _ref3.children;

  // Be used to indicate if button is focused by tab press.
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isFocusedByTab = _useState2[0],
      setIsFocusedByTab = _useState2[1];

  var sortingIcon;

  if (sortDirection === _interfaces.SortDirection.Ascending) {
    sortingIcon = (0, _core.jsx)(_icons.IconSortAscending, {
      "aria-hidden": true,
      color: _constants3.TABLE_HEADER_BUTTON_SORT_ICON_COLOR,
      size: _icons.IconSize.ExtraSmall
    });
  } else if (sortDirection === _interfaces.SortDirection.Descending) {
    sortingIcon = (0, _core.jsx)(_icons.IconSortDescending, {
      "aria-hidden": true,
      color: _constants3.TABLE_HEADER_BUTTON_SORT_ICON_COLOR,
      size: _icons.IconSize.ExtraSmall
    });
  } else {
    sortingIcon = (0, _core.jsx)(_icons.IconSort, {
      "aria-hidden": true,
      color: _constants3.TABLE_HEADER_BUTTON_SORT_ICON_COLOR,
      size: _icons.IconSize.ExtraSmall
    });
  }

  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === _constants.EventKeys.TAB) {
      setIsFocusedByTab(true);
    }
  };

  var handleBlur = function handleBlur() {
    setIsFocusedByTab(false);
  };

  return (0, _core.jsx)(TableHeaderButtonBase, {
    title: titleText,
    onClick: onClick,
    isFocusedByTab: isFocusedByTab,
    onKeyUp: handleKeyUp,
    onBlur: handleBlur
  }, (0, _core.jsx)(TableHeaderButtonContent, {
    spacing: spacing,
    alignItems: "center",
    justifyContent: justifyContent,
    gridGap: "S100"
  }, !!children && children, sortingIcon));
};

var _default = TableHeaderButton;
exports.default = _default;